import axios from "axios";
import { email, required, helpers } from "vuelidate/lib/validators";

const BR_STATES = [
  { uf: "AC", name: "Acre" },
  { uf: "AL", name: "Alagoas" },
  { uf: "AP", name: "Amapá" },
  { uf: "AM", name: "Amazonas" },
  { uf: "BA", name: "Bahia" },
  { uf: "CE", name: "Ceará" },
  { uf: "DF", name: "Distrito Federal" },
  { uf: "ES", name: "Espírito Santo" },
  { uf: "GO", name: "Goiás" },
  { uf: "MA", name: "Maranhão" },
  { uf: "MT", name: "Mato Grosso" },
  { uf: "MS", name: "Mato Grosso do Sul" },
  { uf: "MG", name: "Minas Gerais" },
  { uf: "PA", name: "Pará" },
  { uf: "PB", name: "Paraíba" },
  { uf: "PR", name: "Paraná" },
  { uf: "PE", name: "Pernambuco" },
  { uf: "PI", name: "Piauí" },
  { uf: "RJ", name: "Rio de Janeiro" },
  { uf: "RN", name: "Rio Grande do Norte" },
  { uf: "RS", name: "Rio Grande do Sul" },
  { uf: "RO", name: "Rondônia" },
  { uf: "RR", name: "Roraima" },
  { uf: "SC", name: "Santa Catarina" },
  { uf: "SP", name: "São Paulo" },
  { uf: "SE", name: "Sergipe" },
  { uf: "TO", name: "Tocantins" },
];

function isValidCpf(value) {
  if (!value) return false;
  const cpf = String(value).replace(/\D/g, "");
  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(cpf.charAt(i)) * (10 - i);
  let d1 = (sum * 10) % 11;
  if (d1 === 10) d1 = 0;
  if (d1 !== parseInt(cpf.charAt(9))) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(cpf.charAt(i)) * (11 - i);
  let d2 = (sum * 10) % 11;
  if (d2 === 10) d2 = 0;
  if (d2 !== parseInt(cpf.charAt(10))) return false;

  return true;
}

const cpfValidator = helpers.withParams(
  { type: "cpf" },
  (value) => !helpers.req(value) || isValidCpf(value)
);

export default {
  name: "PsychologistEdit",
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  data() {
    return {
      item: {},
      errorMessage: "",
      submitting: false,
      loadingItems: false,
      fetchingCep: false,
      cepError: "",
      states: BR_STATES,
      genderOptions: [
        { value: "male", label: "Masculino" },
        { value: "female", label: "Feminino" },
        { value: "uninformed", label: "Não informado" },
      ],
      id: this.$route.params.id,
      form: {
        name: "",
        email: "",
        phone: "",
        country_code: "",
        birth_date: "",
        document_number: "",
        crp: "",
        gender: "",
        address_city: "",
        address_state: "",
        address_postal_code: "",
        address_line1: "",
        address_line2: "",
      },
    };
  },
  watch: {
    "form.address_postal_code"(newValue, oldValue) {
      if (newValue === oldValue) return;
      const cleaned = (newValue || "").replace(/\D/g, "");
      if (cleaned.length === 8) {
        this.fetchAddressByCep(cleaned);
      }
    },
  },
  validations: {
    form: {
      name: { required },
      email: { required, email },
      phone: { required },
      country_code: { required },
      birth_date: {},
      document_number: { cpf: cpfValidator },
      crp: {},
      gender: {},
      address_city: {},
      address_state: {},
      address_postal_code: {},
      address_line1: {},
      address_line2: {},
    },
  },
  methods: {
    async getData() {
      try {
        const res = await this.$userService.show(this.id);
        const data = res.data;
        this.$set(this, "form", {
          name: data.name || "",
          email: data.email || "",
          phone: data.phone || "",
          country_code: data.country_code || "",
          birth_date: data.birth_date || "",
          document_number: data.document_number || "",
          crp: data.crp || "",
          gender: data.gender || "",
          address_city: data.address_city || "",
          address_state: data.address_state || "",
          address_postal_code: data.address_postal_code || "",
          address_line1: data.address_line1 || "",
          address_line2: data.address_line2 || "",
        });
        this.$set(this, "item", data);
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingItems = false;
      }
    },
    async fetchAddressByCep(cep) {
      this.fetchingCep = true;
      this.cepError = "";
      try {
        const res = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
        if (res.data && !res.data.erro) {
          this.$set(this.form, "address_line1", res.data.logradouro || this.form.address_line1);
          this.$set(this.form, "address_city", res.data.localidade || this.form.address_city);
          this.$set(this.form, "address_state", res.data.uf || this.form.address_state);
        } else {
          this.cepError = "CEP não encontrado.";
        }
      } catch (e) {
        this.cepError = "Erro ao buscar CEP.";
      } finally {
        this.fetchingCep = false;
      }
    },
    async submit() {
      try {
        this.submitting = true;
        this.errorMessage = "";
        await this.$userService.update(this.id, this.form);
        this.$eventBus.$emit("showToast", {
          title: "Psicólogo atualizado",
          msg: "Dados do psicólogo alterados com sucesso.",
        });
        this.$router.push(`${this.$paths.psychologists.detail}/${this.id}`);
      } catch (e) {
        this.errorMessage = e.message || "Erro ao atualizar o psicólogo.";
      } finally {
        this.submitting = false;
      }
    },
  },
};
